import { SerializableObject } from '../../common-react/core';

import { ICardPaymentOptions } from '../interfaces/card-payment-options.interface';
import { ProductTypeToPayFor } from '../other/product-type-to-pay-for.enum';

import { PaymentCard } from './payment-card.do';

/** @deprecated use ICardPaymentOptions */
export class PaymentCardForm extends SerializableObject implements ICardPaymentOptions {
  public product: ProductTypeToPayFor;
  public salesOffice: string;
  public items: string[];
  public card: PaymentCard;
}
